import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const cssPrefix = 'AddOAuthClientDialog';
export namespace AddOAuthClientDialogStyles {

  export const innerContentContainer = cssClass(cssPrefix, 'inner-content-container', {
    flex: '1',
    minWidth: 0 // To contain text inside
  });

  export const fileSelectionContainer = cssClass(cssPrefix, 'file-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '280px', height: 'auto',
    padding: '8px',
    marginBottom: '8px',
    border: '2px dashed',
    position: 'relative'
  });

  export const dragAndDropChildren = cssClass(cssPrefix, 'inner-container', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    zIndex: 1, // Elevate children above ::after
  });

  export const textMargin = cssClass(cssPrefix, 'text-margin', {
    marginTop: '0px',
    marginBottom: '8px',
    textAlign: 'center',
  });

  export const invalidFileColor = cssClass(cssPrefix, 'invalid-color', {
    color: applyColor(DesignTokens.color.font.default.error, TabStyles.Colors.AttentionDark),
  });

  export const validFileColor = cssClass(cssPrefix, 'valid-color', {
    color: applyColor(DesignTokens.color.feedback.default.success_light, '#00a370'),
  });

  export const defaultFileColor = cssClass(cssPrefix, 'default-color', {
    color: applyColor(DesignTokens.color.font.inverse.default, '#ccc'),
  });

  export const dropdownStyle = cssClass(cssPrefix, 'dropdown-style', {
    width: 300
  });

  export const spinnerStyle = cssClass(cssPrefix, 'spinner-style', {
    lineHeight: 'normal',
    padding: 5,
    display: 'inline-block'
  });
}
